<template>
  <div class="caseList">
    <div class="page-heading" style="background-image: url('static/menhu/images/pp4.jpg')">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h1>产品案例</h1>
            <span>专业服务，梵蒂斯成功案例</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 荣誉列表 -->
    <div class="gtDiv">
      <div class="simple-recent-projects projects-page full-screen-projects filter-projects section-gap">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12">
              <div class="row masonry-layout filters-content normal-col-gap">
                <div  v-for="(item,index) in caseList" :key="index" class="col-lg-3 masonry-item all category-building">
                  <div class="item">
                    <div class="project-item">
                      <div class="thumb">
                        <el-image
                          @click="doCaseClick(item.id)"
                          style="width: 100%;height: 100%;"
                          :src="$fileDPath+(item.imgs.split(',')[0])"
                          fit="cover"></el-image>
                        <div class="hover">
                          <div class="inner-content"  @click="doCaseClick(item.id)">
                            <h4><a style="cursor: pointer">{{ item.name }}</a></h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <caseDesc v-if="isShow" :id="nowID" :isShow="isShow" @close="isShow=false;nowID=null" />

  </div>
</template>

<script>
import caseDesc from '@/components/views/compCase/caseDesc.vue';
export default {
  name: 'caseList',
  components:{caseDesc},
  data() {
    return {
      caseList:[],
      isShow:false,
      nowID:null
    }
  },
  created() {
    this.getData();
  },
  methods:{
    getData(){
      let _this = this;
      this.$axios.get('/fantis/cases/ftCmsCases/list?pageNo=1&pageSize=999')
        .then(function(res){ // 请求成功 HTTP状态码是200
          if(res.data.code == 200){
            var tempData = res.data.result;

            _this.caseList = tempData.records;
          }else{
            _this.$message.error(res.data.msg);
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    },
    // 点击图片
    doCaseClick(id){
      this.nowID = id;
      this.isShow = true;
    }
  }
}
</script>

<style scoped>
.gtDiv {
  width: 100%;
  text-align: center;
  box-sizing: border-box;
  padding: 0px 20px 0px 20px;
}

.thumb{
  /* box-shadow: 1px 1px 12px gray; */
  width: 100%;
  height: 240px;
  max-height: 240px;
  padding: 10px;
  border-radius: 14px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)

}
</style>



// WEBPACK FOOTER //
// src/components/views/compCase/caseList.vue